import React from "react";
import { Phone } from "lucide-react";

export default function MobileCallBar() {
    return (
        <a
            href="tel:7209661797"
            data-testid="mobile-call-bar"
            className="md:hidden fixed bottom-0 inset-x-0 z-50 flex items-center justify-center gap-3 bg-gold text-obsidian font-semibold text-sm py-4 px-6 shadow-[0_-8px_30px_rgba(212,175,55,0.25)]"
        >
            <Phone size={16} strokeWidth={2.6} />
            Call Now — 7209661797
        </a>
    );
}
